module.exports = __webpack_public_path__ + "img/17.2da469a3.png";